import React, { useState, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import NavBar from "./NavBar";
import Breadcrumb from "./Breadcrumb";

const MOBILE_BREAKPOINT = 768;

function Layout() {
    const [merchantId, setMerchantId] = useState(localStorage.getItem("using_merchant_id", ""));
    const [merchantName, setMerchantName] = useState(localStorage.getItem("merchant_title", "All"));
    const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

    const [sidebarOpen, setSidebarOpen] = useState(!isMobile());
    const [animated, setAnimated] = useState(false);
    const location = useLocation();

    // Close drawer on mobile when route changes
    useEffect(() => {
        if (isMobile()) {
            setAnimated(false);
            setSidebarOpen(false);
        }
    }, [location.pathname]);

    // Sync sidebar state when window is resized across the breakpoint
    useEffect(() => {
        const handleResize = () => {
            setAnimated(false);
            setSidebarOpen(!isMobile());
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleDataFromChild = (merchantId, merchantName) => {
        setMerchantId(merchantId);
        setMerchantName(merchantName);
    };

    const handleToggle = () => {
        setAnimated(true);
        setSidebarOpen(v => !v);
    };

    return (
        <div className={sidebarOpen ? 'layout--sidebar-open' : 'layout--sidebar-closed'}>
            <TopBar />
            <NavBar isOpen={sidebarOpen} animated={animated} onToggle={handleToggle} />
            <section className="content contact">
                <div className="container">
                    <Breadcrumb sendDataToParent={handleDataFromChild} />
                    <Outlet context={{ merchantId, merchantName }} />
                </div>
            </section>
        </div>
    );
}

export default Layout;
